import { useLocation } from "react-router-dom";
import styles from "./nav.module.scss";
import { IMenuItem } from "@/common/models/menuItem";
import { useTranslation } from "react-i18next";
import NavMenuItem from "./menuItem";

export const Nav = (props: {
  isSideBarOpen: boolean;
  menuItems: IMenuItem[];
  isPrimary?: boolean;
}) => {
  const { t: translate } = useTranslation();
  const location = useLocation();
  return (
    <ul
      className={`${styles.nav} ${props.isPrimary ? styles.navPrimary : ""}`}
      data-cy="user-controls"
    >
      {props?.menuItems?.map((item: IMenuItem, index: number) => (
        <NavMenuItem
          key={`menu-item-${index}`}
          item={item}
          to={
            location.pathname.includes(item.path)
              ? location.pathname
              : item.path
          }
          name={`${translate(item.name)}`}
          index={index}
          isSideBarOpen={props.isSideBarOpen}
        />
      ))}
    </ul>
  );
};
